// src/components/ui/PermissionLoading.tsx -- Slice I.
//
// Tiny placeholder shown by admin-gated pages while /api/me is in flight.
// Replaces the brief flash of "Admins only" that users saw before
// useCurrentUser resolved their permissions.

import { C, F } from "../../theme";
import { Card } from "./Card";
import { TopBar } from "./TopBar";

export interface PermissionLoadingProps {
  title: string;
  onBack?: () => void;
}

export function PermissionLoading({ title, onBack }: PermissionLoadingProps) {
  return (
    <div>
      <TopBar title={title} sub="Loading" onBack={onBack} />
      <div style={{ padding: "18px 16px" }}>
        <Card>
          <div style={{ fontFamily: F.serif, fontSize: 17, fontWeight: 700, color: C.ink, marginBottom: 6 }}>
            One moment
          </div>
          <p style={{ fontFamily: F.body, fontSize: 14, color: C.inkSoft, fontWeight: 600, margin: 0, lineHeight: 1.5 }}>
            Checking permissions for this application
          </p>
        </Card>
      </div>
    </div>
  );
}
